    import { useCallback, useState } from 'react'
    import { authHeaders } from '../utils/authFetch'

    // const BASE_URL = process.env.REACT_APP_API_URL || 'https://capstone-project-production-62e5.up.railway.app'
    const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'


    export default function useMarketIntelligenceCache() {
        const [loading, setLoading] = useState(false)
        const [error, setError] = useState(null)

        const loadCached = useCallback(async (branchId) => {
            setLoading(true)
            setError(null)
            try {
                const res = await fetch(`${BASE_URL}/api/market-intelligence/cache/${branchId}`, { headers: authHeaders() })
                if (!res.ok) throw new Error('Failed to load cache')
                const data = await res.json()
                setLoading(false)

                if (!data) return null
                return {
                    competitors: data.competitors,
                    feedbackSummary: data.feedbackSummary,
                    swot: data.swot,
                    menuGaps: data.menuGaps,
                    kpis: data.kpis,
                    generatedAt: data.generatedAt ? new Date(data.generatedAt) : null,
                }
            } catch (err) {
                setError(err.message)
                setLoading(false)
                return null
            }
        }, [])

        const upsertCache = useCallback(async (branchId, branchName, payload) => {
            try {
                const res = await fetch(`${BASE_URL}/api/market-intelligence/cache`, {
                    method: 'POST',
                     headers: { 'Content-Type': 'application/json', ...authHeaders() },
                    body: JSON.stringify({
                        branchId,
                        branchName,
                        competitors: payload.competitors,
                        feedbackSummary: payload.feedbackSummary,
                        swot: payload.swot,
                        menuGaps: payload.menuGaps,
                        kpis: payload.kpis,
                    }),
                })
                if (!res.ok) {
                    const body = await res.json().catch(() => ({}))
                    return { error: new Error(body.error || 'Failed to save cache') }
                }
                return { error: null }
            } catch (err) {
                return { error: err }
            }
        }, [])

        return { loadCached, upsertCache, loading, error }
    }